import { Mail, Phone, MapPin, Globe, Clock } from "lucide-react";
import { useSeo } from "../lib/seo";
import { CONTACT } from "../data/content";
import { Container } from "../components/site/Ui";
import { Reveal } from "../components/site/Motion";
import { PageHero } from "../components/site/Blocks";
import { EnquiryForm } from "../components/site/EnquiryForm";

const INFO = [
  { icon: Mail, label: "Email", links: CONTACT.emails.map((e) => [e, `mailto:${e}`]) },
  { icon: Phone, label: "Phone", links: CONTACT.phones.map((p) => [p, `tel:${p}`]) },
  ...CONTACT.offices.map((o) => ({ icon: MapPin, label: o.label, value: o.value })),
  { icon: Globe, label: "Website", value: CONTACT.website, href: "https://www.apptarget.ai" },
  { icon: Clock, label: "Response", value: "We aim to reply to every business enquiry promptly." },
];

export default function Contact() {
  useSeo("Contact Us", "Contact AppTarget Advertising Pvt. Ltd. about advertiser campaigns, publisher partnerships and agency collaborations.", "/contact");
  return (
    <>
      <PageHero eyebrow="Contact Us" lines={["Let’s talk about", "your growth."]} testid="contact-hero"
        text="Whether you are an advertiser, publisher, agency or traffic partner, send us a message and our team will get back to you." />
      <section className="bg-white pb-24" data-testid="contact-section">
        <Container className="grid gap-8 lg:grid-cols-12">
          <Reveal className="card-soft !translate-y-0 p-6 sm:p-10 lg:col-span-8">
            <h2 className="font-display text-2xl font-bold text-[#102B50]">Send an enquiry</h2>
            <p className="mb-8 mt-2 text-sm text-[#5A6D88]">Fields marked * are required.</p>
            <EnquiryForm source="contact" />
          </Reveal>
          <Reveal delay={0.1} className="relative overflow-hidden rounded-2xl bg-[#102B50] p-8 text-white lg:col-span-4">
            <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#2878E5]/40 blur-[90px]" />
            <h2 className="relative font-display text-2xl font-bold">Contact details</h2>
            <ul className="relative mt-8 space-y-6">
              {INFO.map((c) => (
                <li key={c.label} className="flex gap-4" data-testid={`contact-info-${c.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10"><c.icon className="h-4 w-4 text-[#8EC0FF]" /></span>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#8EC0FF]">{c.label}</p>
                    {c.links ? c.links.map(([t, h]) => <a key={t} href={h} className="mt-1 block break-all text-slate-200 hover:text-white">{t}</a>)
                      : c.href ? <a href={c.href} className="mt-1 block text-slate-200 hover:text-white">{c.value}</a> : <p className="mt-1 text-slate-200">{c.value}</p>}
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </Container>
      </section>
    </>
  );
}
